import BaseApiModel from "scripts/models/baseApiModel";

class MediaModel extends BaseApiModel {
  urlRoot() {
    return `${this.apiUrlRoot}/media/`;
  }
}

export default MediaModel;
